import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, Users, Tag, SlidersHorizontal, Package, Inbox, LineChart, MessageSquareQuote } from "lucide-react";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_buildguard-preview/artifacts/3lbt7aob_nirmantra_ai_icon.png";

export default function PartnerNav({ actions }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const role = localStorage.getItem("partner_role");
  const logout = () => { localStorage.clear(); navigate("/login"); };

  const items = [
    { to: "/manager", label: "Vendors", icon: Users, show: true },
    { to: "/admin/leads", label: "Leads", icon: Inbox, show: true },
    { to: "/admin/customers", label: "Customers", icon: LineChart, show: true },
    { to: "/admin", label: "Categories & Rewards", icon: Tag, show: role === "admin" },
    { to: "/admin/plans", label: "Advisory Plans", icon: Package, show: role === "admin" },
    { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquareQuote, show: role === "admin" },
    { to: "/admin/estimate", label: "Estimate Config", icon: SlidersHorizontal, show: role === "admin" },
  ].filter((i) => i.show);

  const title = role === "admin" ? "Super Admin" : "Vendor CRM";

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between gap-4">
        <Link to="/manager" className="flex items-center gap-2.5 shrink-0">
          <img src={LOGO} className="h-9 w-9 rounded-xl" alt="" />
          <span className="font-display font-extrabold text-lg hidden sm:block">Nirmantra<span className="text-[#0E9AC8]">.ai</span> <span className="text-slate-400 text-sm font-medium">{title}</span></span>
        </Link>

        <nav className="flex items-center gap-1 overflow-x-auto" data-testid="partner-nav">
          {items.map((it) => {
            const active = pathname === it.to;
            return (
              <Link key={it.to} to={it.to} data-testid={`pnav-${it.label.split(" ")[0].toLowerCase()}`}
                className={`inline-flex items-center gap-1.5 rounded-xl px-3.5 py-2 text-sm font-medium whitespace-nowrap transition-colors ${active ? "bg-[#0E9AC8] text-white" : "text-slate-600 hover:bg-slate-100 hover:text-[#0E9AC8]"}`}>
                <it.icon className="h-4 w-4" strokeWidth={1.75} /> {it.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2 shrink-0">
          {actions}
          <Button variant="ghost" size="sm" onClick={logout} data-testid="partner-signout" className="text-slate-500">
            <LogOut className="h-4 w-4 sm:mr-1.5" /> <span className="hidden sm:inline">Sign out</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
